import { Product, ProductVariant } from '@/types/Product';

const findAllVariants = (
  products: Product[] = [],
  sku?: string,
): ProductVariant[] => {
  if (sku) {
    const selectedProduct = products.find((product) =>
      product.variants?.some((variant) => variant?.skuCode === sku),
    );

    return (selectedProduct?.variants ?? []) as ProductVariant[];
  }

  return products
    .flatMap((product) => (product.variants ?? []) as ProductVariant[])
    .filter((variant) => variant);
};

export default findAllVariants;
